import { render, staticRenderFns } from "./LocationSublocations.vue?vue&type=template&id=33647325&"
import script from "./LocationSublocations.vue?vue&type=script&lang=js&"
export * from "./LocationSublocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports